export default "/app/global-wrapper-client/static/4b11bb47674ff0df907891e34ffc4590.ttf";